import { render, staticRenderFns } from "./DiscreteStudyVD.vue?vue&type=template&id=3f04a036&scoped=true&"
import script from "./DiscreteStudyVD.vue?vue&type=script&lang=js&"
export * from "./DiscreteStudyVD.vue?vue&type=script&lang=js&"
import style0 from "./DiscreteStudyVD.vue?vue&type=style&index=0&id=3f04a036&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f04a036",
  null
  
)

export default component.exports